import React from 'react';
import {createRoot} from "react-dom/client";
import './index.css';
import * as serviceWorker from './serviceWorker';
import './i18n/i18n'; // initialise i18n before any module that resolves labels at import time
import {App} from './App';
import {configure} from "mobx";
import {CssBaseline, StyledEngineProvider} from "@mui/material";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {EChartProvider} from './services/echarts/EChartProvider';
import {environment} from './env';

configure({enforceActions: "observed"}); // TODO: verify correct migration of mobx5 -> 6

dayjs.extend(relativeTime)

// noinspection JSUnusedAssignment
const useTest: boolean = false;
/**
 * Uncomment the following line to run the tests from ./test/tests.tsx
 */
// useTest = true;

// Taken from https://prawira.medium.com/react-conditional-import-conditional-css-import-110cc58e0da6
const Tests = React.lazy(() => import('./test/tests'));
const container = document.getElementById('root');
const root = createRoot(container!);

async function bootstrap() {
    if (environment.enableMsw) {
        const {enableMocks} = await import('./mocks/enableMocks');
        await enableMocks();
    }

    root.render(
        <React.StrictMode>
            <CssBaseline/>
            <StyledEngineProvider>
                <EChartProvider>
                    {useTest
                        ? <React.Suspense fallback={<></>}><Tests/></React.Suspense>
                        : <App/>}
                </EChartProvider>
            </StyledEngineProvider>
        </React.StrictMode>
    );
}

void bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
